export default __webpack_public_path__ + "static/media/24.9924ff08.png";